'use client';

import Script from 'next/script';
import React from 'react';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';

import { ID_CINEMOON } from '@cineamo/api/constants/cinema-ids';

type MojitofilmsScriptsProps = {
    cinemaId: CinemaDto['id'];
};

const MOJITO_FILMS_WIDGET_ID = {
    [ID_CINEMOON]: 'mw_pub_P-j_oSAZ2T_YOklEYJ6VyOUj'
};

/**
 * Mojitofilms scripts for the cinema website.
 * CURRENTLY ONLY VISIBLE FOR: cinemoon.de
 */
const MojitofilmsScripts: React.FC<MojitofilmsScriptsProps> = ({ cinemaId }) => {
    const widgetId =
        cinemaId in MOJITO_FILMS_WIDGET_ID
            ? MOJITO_FILMS_WIDGET_ID[cinemaId as keyof typeof MOJITO_FILMS_WIDGET_ID]
            : null;
    if (!widgetId) {
        return null;
    }
    return (
        <Script
            async
            src="https://widget.mojitofilms.com/v1/loader.js"
            data-moji-widget={widgetId}></Script>
    );
};

export default MojitofilmsScripts;
